import { Injectable } from '@angular/core';
import { NextObserver, Observable, Subject } from 'rxjs';
import { environment } from '@environments/environment';
import { FacebookAuthResponse } from '@core/models/FacebookAuthResponse';
import { HttpClient } from '@angular/common/http';
declare const FB: any;
@Injectable({
  providedIn: 'root',
})
export class SocialLoginService {
  response = new Subject();
  idFacebookFirmado: string;
  public observable: Observable<string>;
  private subject: Subject<string>;
  constructor(private http: HttpClient) {
    this.fbLibrary();
    this.subject = new Subject();
    this.observable = this.subject.asObservable();
  }

  public fbLibrary() {
    (function (d, s, id) {
      let js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = environment.sdk_face;
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
    (window as any).fbAsyncInit = function () {
      FB.init({
        appId: environment.appId_face,
        cookie: true,
        xfbml: true,
        version: 'v6.0',
      });
    };
  }

  loginStatus(): Observable<FacebookAuthResponse> {
    return new Observable((observer: NextObserver<FacebookAuthResponse>) => {
      setTimeout(() => {
        FB.getLoginStatus((response: any) => {
          if (response.status === 'connected') {
            this.verificarUsuario(response.authResponse.signedRequest).subscribe(async (res) => {
              await res;
              if (res === false && response.status === 'connected') {
                this.agregarUsuario(response.authResponse.accessToken).subscribe((res) => {});
              }
            });
            this.idFacebookFirmado = response.authResponse.signedRequest;
            this.subject.next(response.authResponse.signedRequest);
            observer.next(response.authResponse);
            observer.complete();
          } else {
            observer.next(null);
          }
        });
      }, 1500);
    });
  }

  facebookLogin(): Observable<FacebookAuthResponse> {
    return new Observable((observer: NextObserver<FacebookAuthResponse>) => {
      FB.login(async (response: any) => {
        if (response.status === 'connected') {
          this.verificarUsuario(response.authResponse.signedRequest).subscribe(async (res) => {
            await res;
            if (res === false && response.status === 'connected') {
              this.agregarUsuario(response.authResponse.accessToken).subscribe((res) => {});
            }
          });
          this.idFacebookFirmado = response.authResponse.signedRequest;
          this.subject.next(response.authResponse.signedRequest);
          observer.next(response.authResponse);
          observer.complete();
        } else {
          observer.next(null);
        }
      });
    });
  }

  verificarUsuario(token) {
    return this.http.get(
      `${environment.apiGetNet}clientes/usuario_facebook?facebook_signedRequest=${token}`,
    );
  }

  agregarUsuario(token) {
    return this.http.put(
      `${environment.apiGetNet}clientes/usuario_facebook?facebook_accessToken=${token}`,
      null,
    );
  }
}
